import { useNavigate } from "react-router-dom";
import "./industriesCategories.css";
import Header from "../home-page/home-comps/Header";
import Footer from "../home-page/home-comps/Footer";
import { industriesCategoriesData } from "../../../industriesCategoriesData";

export default function IndustriesCategories() {
  const redirect = useNavigate();

  return (
    <section className="sectionIndustries fx-cl fx-ac space6">
      <Header />
      <div className="fx-cl pd3 space6" style={{ maxWidth: "130rem" }}>
        {industriesCategoriesData.map((group, index) => (
          <div key={index} className="fx-cl spacem">
            <span className="fs6  ">{group.section}</span>

            {group.description && (
              <p className="fs4 pdlargeY pdlargeX ">{group.description}</p>
            )}

            <div className={`g g3 space2 ${group.class || ""} `}>
              {group.items.map((item, i) => (
                <div
                  key={i}
                  className={`solutionsDropdwnCard fx-as space2`}
                  onClick={() => redirect(item.link)}
                >
                  <div className=" fx-ac fx-jc">
                    <span className="fs7">{item.icon}</span>
                  </div>

                  <div className="fx-cl spacem">
                    <h4 className="fs5 fw500">{item.title}</h4>
                    <p className="fs5 lh1">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </section>
  );
}
